/**
 * Bereich fuer Schnellerfassungen.
 *
 * Eine Schnellerfassung ist ein einziges Feld - dort soll man nicht erst
 * einen Bereich waehlen muessen. Der neue Eintrag erbt deshalb den
 * gefilterten Bereich (siehe `defaultAreaForNew`).
 *
 * Nur wenn ZWEI oder mehr Bereiche gefiltert sind, ist die Absicht nicht
 * eindeutig. Dann erscheint neben dem Feld eine kleine Auswahl, vorbelegt mit
 * dem ersten - man sieht, wohin der Eintrag geht, und muss trotzdem nichts
 * anklicken.
 */
import { useState } from 'react';

import { defaultAreaForNew, useAreaFilter } from '@/store/areaFilter';
import type { ID } from '@/domain/types';

export function useCaptureArea(): {
  areaId: ID | null;
  setAreaId: (id: ID) => void;
  choices: ID[];
} {
  const { activeAreaIds } = useAreaFilter();
  const [chosen, setChosen] = useState<ID | null>(null);

  // Abgeleitet statt gespeichert: aendert sich der Filter, faellt eine
  // Auswahl, die nicht mehr sichtbar waere, von selbst auf die Vorgabe zurueck.
  const areaId = chosen !== null && activeAreaIds.includes(chosen)
    ? chosen
    : defaultAreaForNew(activeAreaIds);

  return { areaId, setAreaId: setChosen, choices: activeAreaIds };
}
